import { Actor, Engine } from "excalibur";
import { LevelOne } from "../../scenes/level-one/level-one";
import { DiamondShark } from "../enemies/diamond_shark";
import { Enemy } from "../enemies/enemy";
import { HeartShark } from "../enemies/heart_shark";
import { Shark } from "../enemies/shark";

export class WaveGenerator extends Actor {
    private playTime = 2000;
    private nextEnemyTime = 2000;

    private easiness = 3.0;

    constructor(private level: LevelOne) {
        super();
    }

    onPostUpdate(engine: Engine, delta: number) {
        if (this.level.rolling) {
            this.playTime += delta;

            if (this.playTime > this.nextEnemyTime) {
                this.level.addEnemy(
                    this.getRandomShark()
                )

                this.playTime = 0;

                this.nextEnemyTime = this.randomDev(2000, 1900) * this.easiness;

            }

            this.easiness *= 0.9999
            console.log(this.easiness);
        }
    }

    private randomDev(mean: number, dev: number) {
        return mean + (Math.random() * 2 * dev) - dev;
    }   
    
    private getRandomShark() {
        if (Math.random() < 0.5) {
            return new Shark(this.level);
        } else if (Math.random() < 0.85) {
            return new HeartShark(this.level);
        } else {
            return new DiamondShark(this.level);
        }
    }
}